import {
  forwardRef, type PropsWithChildren,
} from 'react';
import { dataCellStyle } from '~/_shared/baseComponents/table/table.styles';

type TableDataCell = PropsWithChildren<{
  readonly className?: string;
}>;

export const TableDataCellComponent = forwardRef<HTMLDivElement, TableDataCell>(({
  className,
  children,
  ...restProps
}, ref) => {
  return (
    <div
      {...restProps}
      className={className}
      css={dataCellStyle}
      ref={ref}
    >
      {children}
    </div>
  );
});
